import React, { useEffect } from "react"
import "./chat.scss"

const Chat = () => {
  const haveChat = ["es-CO", "es-PR"]

  const initESW = function (gslbBaseURL) {
    window.embedded_svc = window.embedded_svc || []
    window.embedded_svc.settings.displayHelpButton = true; //Or false
    window.embedded_svc.settings.language = 'es-MX'; //For example, enter 'en' or 'en-US'

    window.embedded_svc.settings.autoOpenPostChat = true;
    window.embedded_svc.settings.defaultMinimizedText =
      process.env.LOCALE === "es-CO" ? "Chat en línea" : "Chat con un asesor" //(Toma como valor predeterminado SesiÃ³n de chat con un experto)
    window.embedded_svc.settings.disabledMinimizedText = "Asesor sin conexión" //(Toma como valor predeterminado Agente sin conexiÃ³n)
    window.embedded_svc.settings.loadingText = "Cargando" //(Toma como valor predeterminado Cargando)

    //embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
    //embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

    // Settings for Chat
    //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
    // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
    // Returns a valid button ID.
    //};
    //embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
    //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
    //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)

    window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
    window.embedded_svc.settings.entryFeature = 'LiveAgent';

    window.embedded_svc.settings.extraPrechatFormDetails = [
      { "label": "RecordTypeId", "value": "0123j000000XA07AAG", "displayToAgent": true },
      { "label": "Nombre", "transcriptFields": ["GRF_Nombre_Prechat__c"] },
      { "label": "Apellidos", "transcriptFields": ["GRF_Apellidos_Prechat__c"] },
      { "label": "Email", "transcriptFields": ["GRF_Correo_Prechat__c"] },
      { "label": "Tipo de identificación", "transcriptFields": ["GRF_Tipo_Documento_Prechat__c"] },
      { "label": "Número de Identificación", "transcriptFields": ["GRF_Numero_Documento_Prechat__c"] },
      { "label": "Ciudad", "transcriptFields": ["GRF_Ciudad_Prechat__c"] },
      { "label": "Teléfono", "transcriptFields": ["GRF_Telefono_Prechat__c"] }];

    window.embedded_svc.settings.extraPrechatInfo = [
      {
        "entityName": "Contact",
        "saveToTranscript": "ContactId",
        "showOnCreate": true,
        "entityFieldMaps": [{
          "fieldName": "FirstName",
          "doFind": false,
          "doCreate": false,
          "label": "Nombre"
        }, {
          "fieldName": "LastName",
          "doFind": false,
          "doCreate": false,
          "label": "Apellidos"
        }, {
          "fieldName": "Email",
          "doFind": true,
          "doCreate": false,
          "label": "Email"
        }, {
          "fieldName": "GRF_NumeroIdentificacion__c",
          "doFind": false,
          "doCreate": false,
          "label": "Número de Identificación"
        }]
      }];

    const culture = "es-PR"
    let GRF_nosotras = 'GRF_B2CNosotras'
    let eswNosotras = 'GRF_B2CNosotras'

    if (process.env.LOCALE === culture) {
      GRF_nosotras = 'GRF_B2CNosotrasPR'
      eswNosotras = 'EmbeddedServiceLiveAgent_Parent04I3j000000ChjPEAS_17bad596a15'
    }

    console.log("embedded_svc", window.embedded_svc)

    window.embedded_svc.init(
      'https://grupofamilia.my.salesforce.com',
      'https://grupofamilia.secure.force.com',
      gslbBaseURL,
      '00D3j0000001yNQ',
      GRF_nosotras,
      {
        baseLiveAgentContentURL: 'https://c.la4-c3-ia2.salesforceliveagent.com/content',
        deploymentId: '5723j000000TWp0',
        buttonId: '5733j000000TXBd',
        baseLiveAgentURL: 'https://d.la4-c3-ia2.salesforceliveagent.com/chat',
        eswLiveAgentDevName: eswNosotras,
        isOfflineSupportEnabled: false
      }
    );
  }

  useEffect(() => {
    if (haveChat.includes(process.env.LOCALE)) {
      if (!window.embedded_svc) {
        var s = document.createElement('script');
        s.setAttribute('src', 'https://grupofamilia.my.salesforce.com/embeddedservice/5.0/esw.min.js');
        s.onload = function () {
          initESW(null);
        };
        document.body.appendChild(s);
      } else {
        initESW('https://service.force.com');
      }
    }
  }, [])

  const setPRChatStyleClass = (tries = 0) => {
    const helpbutton = document.querySelector(".helpButton")
    if (helpbutton instanceof HTMLElement) {
      helpbutton.classList.add("f-chat-pr")
    } else if (tries < 5) {
      window.setTimeout(() => setPRChatStyleClass(tries + 1), 500)
    }
  }

  useEffect(() => {
    if (process.env.LOCALE === "es-PR") {
      setPRChatStyleClass()
    }
  }, [])

  return <></>
}

export default Chat
